import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchSchema = () => api.get("/schema").then((r) => r.data);
export const fetchBeliefs = () => api.get("/beliefs").then((r) => r.data);
export const fetchBelief = (id) => api.get(`/beliefs/${id}`).then((r) => r.data);
export const createBelief = (data) => api.post("/beliefs", data).then((r) => r.data);
export const updateBelief = (id, data) =>
  api.patch(`/beliefs/${id}`, data).then((r) => r.data);
export const fetchGaps = () => api.get("/beliefs/gaps/list").then((r) => r.data);

export const fetchStories = () => api.get("/stories").then((r) => r.data);
export const createStory = (data) => api.post("/stories", data).then((r) => r.data);
export const updateStory = (id, data) =>
  api.patch(`/stories/${id}`, data).then((r) => r.data);

export const triggerSync = () => api.post("/sync").then((r) => r.data);
export const fetchLastSync = () => api.get("/sync/last").then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
